export default __webpack_public_path__ + "static/media/media-auto-1.fdc0b48d.jpg";